export { StandaloneBanner } from './standalone-banner';
